import { useEffect, useState } from "preact/hooks";

import { Event, EventListener } from "./events";
import { useFunctionRef } from "./functionRef";

export function useEvent<T>(event: Event<T>, onChange: EventListener<T>) {
    const ref = useFunctionRef(onChange);
    useEffect(() => {
        if (event.lastEmitted) return event.onWith(ref);
    }, [event, ref]);
}

export function useEventValue<T>(event: Event<T>) {
    const [value, setValue] = useState(event.lastEmitted);

    useEffect(() => {
        return event.onWith(setValue);
    }, [event]);

    return value;
}
